<template>
  <div id="noon-report-list-view">
    <ag-grid-vue
      :style="{ width, height }"
      ref="agGridTable"
      :rowHeight="rowHeight"
      :gridOptions="gridOptions"
      class="ag-theme-material ag-grid-table"
      :columnDefs="columnDefs"
      :defaultColDef="defaultColDef"
      :rowData="reportList"
      rowSelection="single"
      colResizeDefault="shift"
      :animateRows="false"
      :floatingFilter="false"
      :pagination="true"
      :paginationPageSize="paginationPageSize"
      :suppressPaginationPanel="true"
      :suppressDragLeaveHidesColumns="true"
      :suppressNoRowsOverlay="true"
      @grid-ready="onGridReady"
      @rowClicked="rowClicked"
    >
    </ag-grid-vue>
  </div>
</template>

<script>
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import { DeviceInfoMixin, ColorMixin } from "@/mixins";
import moment from "moment-timezone";

import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("vesselNoonReportList");

import CellRendererSender from "./cell-renderer/CellRendererSender";
import CellRendererStatus from "./cell-renderer/CellRendererStatus";
import CellRendererHistory from "./cell-renderer/CellRendererHistory";

export default {
  mixins: [DeviceInfoMixin, ColorMixin],

  components: {
    AgGridVue,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererSender,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererStatus,
    // eslint-disable-next-line vue/no-unused-components
    CellRendererHistory,
  },

  data() {
    return {
      gridApi: null,
      gridColumnApi: null,
      gridOptions: {
        localeText: {
          noRowsToShow: "検索に一致する動静連絡は見つかりませんでした。",
        },
        rowStyle: { cursor: "pointer" },
        context: {
          componentParent: this,
        },
      },
      defaultColDef: {
        sortable: false,
        resizable: true,
      },
      height: "70vh",
      width: "100%",
      rowHeight: 48,
      columnDefs: null,
      funcSizeColumnsToFit: null,
    };
  },

  watch: {
    reports: {
      handler(val) {
        if (val.length === 0) {
          this.onShowOverlayNoRows();
        }
      },
      deep: true,
    },
  },

  computed: {
    ...mapState([
      "reports",
      "searchParameters",
      "currentPage",
      "totalReportCount",
      "totalPage",
      "paginationPageSize",
    ]),
    reportList() {
      if (!this.reports) return [];

      return this.reports.map(report => {
        const vesselName = report.enterprise_vessel.name_ja
          ? report.enterprise_vessel.name_ja
          : report.enterprise_vessel.name;

        const latestHistory = {
          name: "",
          created_at: "",
          action: "",
        };

        if (report.histories || report.histories.length > 0) {
          const history = report.histories[0];
          latestHistory.name = history.changerProfile
            ? history.changerProfile.name
            : "";
          latestHistory.created_at = history.created_at;
          latestHistory.action = history.change;
        }

        const _report = {
          reportId: report.id,
          vesselId: report.enterprise_vessel.id,
          vessel_name: vesselName,
          created_at: moment(report.created_at).format("YYYY/MM/DD HH:mm"),
          sender: report.changerProfile,
          status: {
            label: report.workflow_status.label,
            color: report.workflow_status.category.color,
          },
          history: latestHistory,
        };
        return _report;
      });
    },
  },

  methods: {
    async onGridReady(params) {
      if (params) {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
        this.gridApi.sizeColumnsToFit();

        this.funcSizeColumnsToFit = () => {
          setTimeout(() => {
            params.api.sizeColumnsToFit();
          });
        };

        window.onresize = this.funcSizeColumnsToFit;
      }
    },

    onShowOverlayNoRows() {
      this.gridOptions.suppressNoRowsOverlay = false;
      this.gridApi.showNoRowsOverlay();
    },

    rowClicked(event) {
      this.$router.push({
        name: "addon-vessel-noon-report-detail",
        params: {
          vesselId: event.data.vesselId,
          reportId: event.data.reportId,
        },
      });
    },
  },

  beforeMount() {
    this.columnDefs = [
      {
        headerName: "船舶名",
        sortable: true,
        field: "vessel_name",
        colId: "vessel_name",
        minWidth: 100,
        maxWidth: 180,
      },
      {
        headerName: "送信日時",
        sortable: true,
        field: "created_at",
        colId: "created_at",
        minWidth: 120,
        maxWidth: 180,
      },
      {
        headerName: "送信者",
        sortable: true,
        field: "sender",
        colId: "sender",
        cellRenderer: "CellRendererSender",
        minWidth: 120,
        maxWidth: 180,
      },
      {
        headerName: "ステータス",
        field: "status",
        colId: "status",
        cellRenderer: "CellRendererStatus",
        minWidth: 100,
        maxWidth: 180,
      },
      {
        headerName: "履歴",
        field: "history",
        colId: "history",
        cellRenderer: "CellRendererHistory",
        width: 320,
      },
    ];
  },

  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridColumnApi = this.gridOptions.columnApi;
  },

  beforeDestroy() {
    window.onresize = null;
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";
//@import "@/assets/scss/aisea/vessel-noon-report.scss";

#noon-report-list-view {
  --vs-primary: 3, 155, 229;

  .ag-row .ag-cell {
    display: flex;
    justify-content: left;
    align-items: center;
  }
}
</style>
